export default __webpack_public_path__ + "static/Armar6Teleoperation-9522f50bb512cdc314e5ea31457d580e.png";